import {getPermission} from '../../classes/functions';
import './lateral.css';
import {Menu, MenuItem, Sidebar, SubMenu} from 'react-pro-sidebar';
import {FaChartBar, FaClipboard, FaCog, FaFolderPlus, FaHome} from "react-icons/fa";
import {Link} from 'react-router-dom';
import {useEffect, useState} from "react";

export default function Lateral() {
    const [mainCollapse, setMainCollapse] = useState();
    const [collapses, setCollapses] = useState([false, false, false, false, false]);

    function changeCurrentActivedMenuItem(menuItemIndex){
        setCollapses(collapses.map((collapse, index) => {
            if(menuItemIndex === index){
                collapse = !collapse;
            } else{
                collapse = false;
            }

            return collapse;
        }));
    }

    return (
        <div className="newMenu">
            <Sidebar onMouseEnter={() => setMainCollapse(false)} onMouseLeave={() => setMainCollapse(true)} collapsed={mainCollapse}>
                <Menu iconShape="square" closeOnClick={true}>
                    <Link to="/dashboard" onClick={() => changeCurrentActivedMenuItem(0)}>
                        <MenuItem open={collapses[0]} style={{paddingLeft: "14.5px", width: "250px"}} icon={<FaHome color="#001675" size={24}/>}>
                                <item>Home</item>
                        </MenuItem>
                    </Link>
                    {getPermission('CONFIGURACOES') &&
                        <SubMenu open={collapses[1]} onClick={() => changeCurrentActivedMenuItem(1)} style={{paddingLeft: "14.5px", width: "250px"}} label="Configurações" icon={<FaCog color="#001675" size={24}/>}>
                            <Link to="/parameters">
                                {getPermission('CONFIGURACOES - PARAMETROS') && <MenuItem className="newMenu___item">
                                        <item>Parâmetros</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/general_parameters">
                                {getPermission('CONFIGURACOES - PARAMETROS GERAIS') && <MenuItem className="newMenu___item">
                                        <item>Parâmetros Gerais</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/companies_parameters">
                                {getPermission('CONFIGURACOES - PARAMETROS EMPRESAS') && <MenuItem className="newMenu___item">
                                        <item>Parâmetros Por Empresas</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/urls">
                                {getPermission('CONFIGURACOES - URLS') && <MenuItem className="newMenu___item">        
                                        <item>URLs</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/permissions">
                                {getPermission('CONFIGURACOES - PERMISSOES') && <MenuItem className="newMenu___item">        
                                        <item>Permissões</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/generics">
                                {getPermission('CONFIGURACOES - TABELAS GENERICAS') && <MenuItem className="newMenu___item">        
                                        <item>Tabelas Genéricas</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/features">
                                {getPermission('CONFIGURACOES - CARACTERISTICAS') && <MenuItem className="newMenu___item">        
                                        <item>Características</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/import_data">
                                {getPermission('CONFIGURACOES - IMPORTACAO DADOS') && <MenuItem className="newMenu___item">        
                                        <item>Importação de Dados</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/qr_code">
                                {getPermission('CONFIGURACOES - QRCODE') && <MenuItem className="newMenu___item">        
                                        <item>QR Code APP</item>
                                </MenuItem>}
                            </Link>
                        </SubMenu>}
                    {getPermission('CADASTROS') &&
                        <SubMenu open={collapses[2]} onClick={() => changeCurrentActivedMenuItem(2)} style={{paddingLeft: "14.5px", width: "250px"}} label="Cadastros" icon={<FaFolderPlus color="#001675" size={24}/>}>
                            <Link to="/warehouses">
                                {getPermission('CADASTROS - ARMAZENS') && <MenuItem className="newMenu___item">
                                    <item>Armazéns</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/companies">
                                {getPermission('CADASTROS - EMPRESAS') && <MenuItem className="newMenu___item">
                                    <item>Empresas</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/group_companies">
                                {getPermission('CADASTROS - GRUPOS EMPRESAS') && <MenuItem className="newMenu___item">
                                    <item>Grupos de Empresas</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/group_products">
                                {getPermission('CADASTROS - GRUPOS PRODUTOS') && <MenuItem className="newMenu___item">
                                    <item>Grupos de Produtos</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/profiles">
                                {getPermission('CADASTROS - PERFIS') && <MenuItem className="newMenu___item">
                                    <item>Perfis</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/people">
                                {getPermission('CADASTROS - PESSOAS') && <MenuItem className="newMenu___item">
                                    <item>Pessoas</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/products">
                                {getPermission('CADASTROS - PRODUTOS') && <MenuItem className="newMenu___item">
                                    <item>Produtos</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/types_product">
                                {getPermission('CADASTROS - TIPOS PRODUTOS') && <MenuItem className="newMenu___item">
                                    <item>Tipos de Produtos</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/units">
                                {getPermission('CADASTROS - UNIDADES MEDIDA') && <MenuItem className="newMenu___item">
                                    <item>Unidades de Medida</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/users">
                                {getPermission('CADASTROS - USUARIOS') && <MenuItem className="newMenu___item">
                                    <item>Usuários</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/storage_zones">
                                {getPermission('CADASTROS - ZONAS ARMAZENAGEM') && <MenuItem className="newMenu___item">
                                    <item>Zonas de Armazenagem</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/adresses">
                                {getPermission('CADASTROS - ENDERECOS') && <MenuItem className="newMenu___item">
                                    <item>Endereços</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/services">
                                {getPermission('CADASTROS - SERVICOS') && <MenuItem className="newMenu___item">
                                    <item>Serviços</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/average_cost">
                                {getPermission('CADASTROS - CUSTO MEDIO') && <MenuItem className="newMenu___item">
                                    <item>Custo Médio</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/messages">
                                {getPermission('CADASTROS - MENSAGENS') && <MenuItem className="newMenu___item">
                                    <item>Mensagens</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/employees">
                                {getPermission('CADASTROS - FUNCIONARIOS') && <MenuItem className="newMenu___item">
                                    <item>Funcionários</item>
                                </MenuItem>}
                            </Link>
                        </SubMenu>}
                    {getPermission('OPERACOES') &&
                        <SubMenu open={collapses[3]} onClick={() => changeCurrentActivedMenuItem(3)} style={{paddingLeft: "14.5px", width: "250px"}} label="Operações" icon={<FaChartBar color="#001675" size={24}/>}>
                            <Link to="/tags">
                                {getPermission('OPERACOES - ETIQUETAS') && <MenuItem className="newMenu___item">
                                    <item>Etiquetas</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/entry_documents">
                                {getPermission('OPERACOES - ENTRADA DOCUMENTOS') && <MenuItem className="newMenu___item">
                                    <item>Entrada de Documentos</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/receipt_documents">
                                {getPermission('OPERACOES - CONTROLE RECEBIMENTOS') && <MenuItem className="newMenu___item">
                                    <item>Controle de Recebimentos</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/manual_movement">
                                {getPermission('OPERACOES - MOVIMENTACAO MANUAL') && <MenuItem className="newMenu___item">
                                    <item>Movimentação Manual</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/order_services">
                                {getPermission('OPERACOES - ORDEM SERVICO') && <MenuItem className="newMenu___item">
                                    <item>Ordem de Serviço</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/address_control">
                                {getPermission('OPERACOES - CONTROLE ENDERECAMENTO') && <MenuItem className="newMenu___item">
                                    <item>Controle de Endereçamento</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/order_point">
                                {getPermission('OPERACOES - PONTO PEDIDO') && <MenuItem className="newMenu___item">
                                    <item>Ponto de Pedido</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/product_requests">
                                {getPermission('OPERACOES - REQUISICOES') && <MenuItem className="newMenu___item">
                                    <item>Requisições</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/epis_requests">
                                {getPermission('OPERACOES - REQUISICOES EPIS') && <MenuItem className="newMenu___item">
                                    <item>Requisições EPIs</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/return_request">
                                {getPermission('OPERACOES - REQUISICAO DEVOLUCAO') && <MenuItem className="newMenu___item">
                                    <item>Requisição de Devolução</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/separation-conference">
                                {getPermission('OPERACOES - CONFERENCIA SEPARACAO') && <MenuItem className="newMenu___item">
                                    <item>Conferência de Separação</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/inventory">
                                {getPermission('OPERACOES - INVENTARIO') && <MenuItem className="newMenu___item">
                                    <item>Inventário</item>
                                </MenuItem>}
                            </Link>
                        </SubMenu>}
                    {getPermission('RELATORIOS') &&
                        <SubMenu open={collapses[4]} onClick={() => changeCurrentActivedMenuItem(4)} style={{paddingLeft: "14.5px", width: "250px"}} label="Relatórios" icon={<FaClipboard color="#001675" size={24}/>}>
                            <Link to="/balances">
                                {getPermission('RELATORIOS - CONTROLE SALDOS') && <MenuItem className="newMenu___item">
                                    <item>Controle de Saldos</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/conferred">
                                {getPermission('RELATORIOS - CONFERENCIAS') && <MenuItem className="newMenu___item">
                                    <item>Conferências</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/kardex">
                                {getPermission('RELATORIOS - KARDEX') && <MenuItem className="newMenu___item">
                                    <item>Kardex</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/movements">
                                {getPermission('RELATORIOS - MOVIMENTACAO SAIDA') && <MenuItem className="newMenu___item">
                                    <item>Movimentações de Saída</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/stock_position">
                                {getPermission('RELATORIOS') && <MenuItem className="newMenu___item">
                                    <item>Posição de Estoque</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/logs">
                                {getPermission('RELATORIOS - LOGS') && <MenuItem className="newMenu___item">
                                    <item>Logs</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/integration_error">
                                {getPermission('RELATORIOS - ERRO INTEGRAÇÃO') && <MenuItem className="newMenu___item">
                                    <item>Erro de Integração</item>
                                </MenuItem>}
                            </Link>
                            <Link to="/commitment">
                                {getPermission('RELATORIOS - EMPENHO') && <MenuItem className="newMenu___item">
                                    <item>Empenho</item>
                                </MenuItem>}
                            </Link>
                        </SubMenu>}
                </Menu>
            </Sidebar>
        </div>
    )
}